import { h, Component } from 'preact'
import Icon from '../assets/'
import Popup from '../Popup'

type BANNER = 'banner'
type HTML_WIDGET = 'html_widget'
type BADGES_WIDGET = 'badges'
type TAG_CLOUD = 'tag_cloud'
type LEADERBOARD = 'leaderboard_points'
type EVENT_CALENDAR = 'event_calendar'
type SOLVED_TOPICS_WIDGET = 'solved_topics'
type MOST_LIKED_WIDGET = 'most_liked'
type COMMUNITY_STATISTICS_WIDGET = 'community_statistics'
type QUICKLINKS_WIDGET = 'quick_links'
type RECOMMENDATIONS_WIDGET = 'recommendations'
type FEATURED_TOPICS_WIDGET = 'featured_topics'
type FEATURE_TOPICS_WIDGET = 'feature_topics'
type CATEGORY_AND_TOPIC_STREAM_WIDGET = 'category_and_topics_stream_only'
type CONTAINER_2_1 = 'container_2_1'
type ANNOUNCEMENT_CARD = 'announcement_card'
type INTRODUCTION_BAR = 'introduction_bar'
type STATISTICS_BAR = 'statistics_bar'
type KNOWLEDGE_BASE_WIDGET = 'knowledge_base'
type COMMUNITY_CATEGORY_WIDGET = 'community_category'
type HERO_BANNER = 'hero_banner'
type GROUPS = 'groups'
type IDEATION_PIPELINE = 'ideation_pipeline'
type IDEATION_HERO = 'ideation_hero'
type IDEATION_LIST = 'ideation_list'
type IDEATION_STATUS_FILTER = 'ideation_status_filter'
type PRODUCT_AREA_FILTER = 'product_area_filter'
type HEADER_NAVIGATION = 'header_navigation'
type PRODUCT_UPDATES_HERO = 'product-updates_hero'
type GENERIC_HERO = 'generic_hero'
type IDEATION_STATISTICS_BAR = 'ideation_statistics_bar'

export type TypesThatCanBeAdded = BANNER | HTML_WIDGET | TAG_CLOUD | BADGES_WIDGET |
SOLVED_TOPICS_WIDGET | MOST_LIKED_WIDGET | COMMUNITY_STATISTICS_WIDGET |
LEADERBOARD | QUICKLINKS_WIDGET | RECOMMENDATIONS_WIDGET | FEATURED_TOPICS_WIDGET |
CATEGORY_AND_TOPIC_STREAM_WIDGET | FEATURE_TOPICS_WIDGET | ANNOUNCEMENT_CARD | KNOWLEDGE_BASE_WIDGET |
CONTAINER_2_1 | COMMUNITY_CATEGORY_WIDGET | INTRODUCTION_BAR | STATISTICS_BAR | HERO_BANNER | EVENT_CALENDAR | GROUPS |
IDEATION_PIPELINE | IDEATION_HERO | IDEATION_LIST | IDEATION_STATUS_FILTER | PRODUCT_AREA_FILTER | HEADER_NAVIGATION |
PRODUCT_UPDATES_HERO | IDEATION_STATISTICS_BAR | GENERIC_HERO

export interface widgetsToAddSidebar {
  type: HTML_WIDGET | TAG_CLOUD | BADGES_WIDGET | SOLVED_TOPICS_WIDGET | MOST_LIKED_WIDGET | COMMUNITY_STATISTICS_WIDGET | LEADERBOARD | ANNOUNCEMENT_CARD | EVENT_CALENDAR | IDEATION_STATUS_FILTER | PRODUCT_AREA_FILTER
  title: string
  description: string
}

export interface widgetsToAddMainContent {
  type: HTML_WIDGET | CATEGORY_AND_TOPIC_STREAM_WIDGET | KNOWLEDGE_BASE_WIDGET | COMMUNITY_CATEGORY_WIDGET |
  IDEATION_LIST | QUICKLINKS_WIDGET
  title: string
  description: string
}

export interface widgetsToAddFullWidth {
  type: BANNER | HTML_WIDGET | FEATURED_TOPICS_WIDGET | RECOMMENDATIONS_WIDGET | QUICKLINKS_WIDGET | FEATURE_TOPICS_WIDGET
  | CATEGORY_AND_TOPIC_STREAM_WIDGET | KNOWLEDGE_BASE_WIDGET | CONTAINER_2_1 | COMMUNITY_CATEGORY_WIDGET
  | INTRODUCTION_BAR | STATISTICS_BAR | HERO_BANNER | EVENT_CALENDAR | GROUPS | IDEATION_PIPELINE | IDEATION_HERO
  | IDEATION_LIST | HEADER_NAVIGATION | PRODUCT_UPDATES_HERO | IDEATION_STATISTICS_BAR | GENERIC_HERO
  title: string
  description: string
}

interface SharedProps {
  onWidgetChoice: (type: TypesThatCanBeAdded) => void
  widgetList: Array<widgetsToAddSidebar | widgetsToAddFullWidth | widgetsToAddMainContent>
}

interface Props extends SharedProps {
  onToggle: (isVisible: boolean) => void
  x: number
  y: number
  width?: number
  visible: boolean
  widgetList: Array<widgetsToAddSidebar | widgetsToAddFullWidth | widgetsToAddMainContent>
}

interface State {
  height: number | null
  width: number | null
}

interface PopupProps extends SharedProps {
  onResize: (size: {width: number, height: number}) => void
}

class WidgetsPopup extends Component<PopupProps> {
  ref: HTMLElement | null = null
  height: number | undefined
  width: number | undefined

  resize () {
    if (!this.ref) return
    const rect = this.ref.getBoundingClientRect()
    const width = Math.floor(rect.width)
    const height = Math.floor(rect.height)
    if (this.width === width && this.height === height) return
    this.width = width
    this.height = height
    this.props.onResize({ width, height })
  }

  componentDidMount () {
    this.resize()
  }

  componentDidUpdate () {
    this.resize()
  }

  render ({ widgetList, onWidgetChoice }: PopupProps) {
    return (
      <ul ref={ref => { this.ref = ref }}>
        {
        widgetList.map((widget) => (
          <li
            key={widget.type}
            className={`new-widget-dropdown-item ${widget.type}`}
            onClick={
              () => onWidgetChoice(widget.type)
            }
          >
            <div className='new-widget-dropdown-item-title'>{widget.title}</div>
            <div className='new-widget-dropdown-item-description'>{widget.description}</div>
          </li>
        ))
      }
      </ul>
    )
  }
}

export default class NewButton extends Component<Props, State> {
  ref: HTMLElement | null = null

  constructor () {
    super()
    this.state = {
      width: null,
      height: null
    }
    this.updatePopupRef = this.updatePopupRef.bind(this)
  }

  updatePopupRef (popupRef: HTMLElement) {
    if (!popupRef) return
    const rect = popupRef.getBoundingClientRect()
    if (this.state.width !== rect.width || this.state.height !== rect.height) {
      this.setState({ width: rect.width, height: rect.height })
    }
  }

  render ({ onToggle, onWidgetChoice, widgetList, visible, x, y }: Props) {
    return (
      <div
        class='new-widget-dropdown-button' ref={el => {
          if (this.state.width === null) {
            this.setState({ width: 0, height: 0 })
          }
          this.ref = el
        }}
        style={{
          top: y,
          left: x < 60 ? 60 : x,
          maxWidth: (this.props.width ?? 0) + 48,
          opacity: visible ? 1 : 0
        }}
      >
        <Icon
          icon='addWidget'
          color='#2B3346'
        />

        {this.ref &&
          <Popup
            hoverControl={this.ref}
            triggerOnClick
            hideOnClickInside
            region='top'
            offset={-56}
            align='start'
            onToggle={isVisible => onToggle(isVisible)}
            popupClass='new-widget-dropdown-list'
            size={{
              width: this.state.width ?? 0,
              height: this.state.height ?? 0
            }}
          >
            <WidgetsPopup widgetList={widgetList} onWidgetChoice={onWidgetChoice} onResize={size => { this.setState(size) }} />
          </Popup>}
      </div>
    )
  }
}
